import { render, staticRenderFns } from "./MovementList.vue?vue&type=template&id=9512f1d6&scoped=true&"
import script from "./MovementList.vue?vue&type=script&lang=js&"
export * from "./MovementList.vue?vue&type=script&lang=js&"
import style0 from "./styles.scss?vue&type=style&index=0&id=9512f1d6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9512f1d6",
  null
  
)

export default component.exports